import { render, staticRenderFns } from "./productUnitConfig.vue?vue&type=template&id=7f35f021&scoped=true&"
import script from "./productUnitConfig.vue?vue&type=script&lang=ts&"
export * from "./productUnitConfig.vue?vue&type=script&lang=ts&"
import style0 from "./productUnitConfig.vue?vue&type=style&index=0&id=7f35f021&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35f021",
  null
  
)

export default component.exports